export enum FILE_UPLOAD_STATES {
  SUCCESS = 'SUCCESS',
  ACCEPTED = 'ACCEPTED',
  EXCEEDS_MAX_SIZE = 'EXCEEDS_MAX_SIZE',
  WRONG_FILE_TYPE = 'WRONG_FILE_TYPE',
}
